import { RematchDispatch } from '@rematch/core';
import { axiosErrorHandler } from 'common/helpers';
import { IRootModel } from 'app/store';
import { IAssessmentHistoryParams } from 'entities/PatientMetrics/PatientMetrics.models';
import { patientMetricsService } from 'entities/PatientMetrics/PatientMetrics.service';

export const patientMetricsEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async getAssessmentHistory(params: IAssessmentHistoryParams) {
    dispatch.patientMetrics.setLoading(true);

    try {
      const response = await patientMetricsService.getAssessmentHistory(params);
      dispatch.patientMetrics.setAssessmentHistory(response.data);
      dispatch.patientMetrics.setCount(response.meta.count);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.patientMetrics.setLoading(false);
    }
  },
});
